import React from "react";
import { Navigate } from "react-router-dom";

// Function to check if the user is authenticated
const isAuthenticated = () => {
  const token = localStorage.getItem("sessiontoken");
  console.log(token);
  const role = localStorage.getItem("userRole"); // Store and check the user role
  return token !== null && token !== "" && role; // Check if role exists
};

// ProtectedRoute component
const ProtectedRoute = ({ element, requiredRole }) => {
  const role = localStorage.getItem("userRole");

  // If user is authenticated and role matches, render the element
  if (isAuthenticated() && role === requiredRole) {
    return element;
  }

  // Redirect based on required role
  if (requiredRole === "admin") {
    return <Navigate to="/admin/login" />;
  }
  if (requiredRole === "reporter") {
    return <Navigate to="/reporter/login" />;
  }

  // Default redirect (fallback)
  return <Navigate to="/" />;
};

export default ProtectedRoute;
